import { Box, Flex, IconButton } from '@chakra-ui/react';
import type { LHCDetails } from '@diamond/shared/types';
import { Text } from '@diamond/shared/ui';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { SyncInfo } from './sync-info';

interface LHCDetailHeaderProps {
  lhc: LHCDetails;
  onBack: () => void;
  onSync?: () => void;
}

export function LHCDetailHeader({ lhc, onBack, onSync }: LHCDetailHeaderProps) {
  return (
    <Flex align="center" justify="space-between" mb={6}>
      <Flex align="center" gap={3}>
        <IconButton
          aria-label="Kembali"
          icon={<ArrowBackIcon />}
          variant="ghost"
          size="sm"
          onClick={onBack}
        />
        <Text fontSize="xl" fontWeight="bold">
          Laporan Harian Collection
        </Text>
        <Text
          as="h2"
          color="#007AFF"
          fontFamily="'Libre Franklin', -apple-system, system-ui, sans-serif"
          fontWeight={400}
          fontStyle="normal"
          fontSize="24px"
          lineHeight="100%"
          letterSpacing="0"
        >
          {lhc.lhc_no || '-'}
        </Text>
      </Flex>
      <Box maxW="453px">
        <SyncInfo lastSyncedAt={lhc.updated_at} onSync={onSync} />
      </Box>
    </Flex>
  );
}
